import { Component, OnInit, Input, Output, ViewChild, ElementRef } from '@angular/core';
import { TranslatorService } from '../../../services';

@Component({
    selector: 'sn-slider',
    templateUrl: './slider.component.html',
    styleUrls: ['./slider.component.css']
})
export class SliderComponent implements OnInit {
    @Input() options: any = { id: '', width: 200, height: 15, min: 0, max: 1000, min_range: 100, step: 10, is_numeric: true, is_percentage: false, value_at_min_max_as_all: true };
    @Input() public onValueChange: Function;
    @Output() public initialize: Function;

    style_class: string = 'slider-container';
    left_slider_state: any = { position: 0, range: 200, clientX: 0, offset: 0, startOffset: 0, width: 0 }
    right_slider_state: any = { position: 0, range: 200, clientX: 0, offset: 0, startOffset: 0, width: 0 }
    min_value: number;
    max_value: number;
    min_value_label: string;
    max_value_label: string;
    initialized:boolean = false;

    constructor(
        public translatorService: TranslatorService,
    ) { }

    ngOnInit() {
        this.initialized = false;
        this.initialize = function(reset_min_max_value:boolean = false) {
            if (!this.initialized || reset_min_max_value) this.min_value = this.options.min;
            if (!this.initialized || reset_min_max_value) this.max_value = this.options.max;
            if (this.options.min_value != this.options.min) this.min_value = this.options.min_value;
            if (this.options.max_value != this.options.max) this.max_value = this.options.max_value;
            this.updateMinMaxLabel();
            this.initialized = true;  // set to true at the end
        }
    }

    getSliderStyle() {
        var width = this.options.width.toString() + 'px';
        var style = {
            "width": width,
        }
        return style;
    }

    getBackgroundFillStyle() {
        return null;
    }

    onSliderChange(event, type) {
        if (type == "min") this.min_value = parseInt(event.target.value);
        if (type == "max") this.max_value = parseInt(event.target.value);

        var min_range:number = this.options.min_range;
        if (this.max_value - this.min_value < min_range) {
            if (type == "min") {
                this.max_value = this.min_value + min_range;
                if (this.max_value > this.options.max) {
                    this.max_value = this.options.max;
                    this.min_value = this.options.max - min_range;
                } 
            } else {
                this.min_value = this.max_value - min_range;
                if (this.min_value < this.options.min) {
                    this.min_value = this.options.min;
                    this.max_value = this.options.min + min_range;
                }
            }
        }
        this.updateMinMaxLabel();
        if (this.onValueChange) {
            this.onValueChange(this.options, this.min_value, this.max_value);
        }
    }

    updateMinMaxLabel() {
        this.min_value_label = this.min_value.toString();
        this.max_value_label = this.max_value.toString();
        if (this.options.is_percentage) {
            this.min_value_label = this.min_value.toString() + "%";
            this.max_value_label = this.max_value.toString() + "%";
        }

        if (this.min_value == this.options.min && this.max_value == this.options.max && this.options.value_at_min_max_as_all) {
            this.max_value_label = this.max_value_label + " (All)";
        }
    }

    getRangeSelectedStyle() {
        var left = (this.min_value / this.options.max * 100).toString() + "%";
        var right = (100 - (this.max_value / this.options.max * 100)).toString() + "%";

        return { "left": left, "right": right }
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/common/slider/slider.component.ts